import { FC } from 'react';
import MainContainer from '../../modules/main/MainContainer';
import { withHeader } from '../../HOC/withHeader';

const MainPageContainer: FC = withHeader(MainContainer);

export default MainPageContainer;
